module.exports = __webpack_public_path__ + "img/Conducteur véhic-ZC-025.7b0b2705.jpg";